exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thumbnail[data-v-80eebe4e] {\n  background-color: #efefef;\n}\n.play[data-v-80eebe4e] {\n  position: absolute;\n  background-color: rgba(189, 175, 138, 0.75);\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  margin: auto;\n}\n.play .fa-play[data-v-80eebe4e] {\n  color: rgba(255, 255, 255, 0.95);\n}\na:hover .play[data-v-80eebe4e] {\n  background-color: rgba(189, 175, 138, 0.6);\n}", ""]);

// exports
